import React from "react";
import { Card, CardBody, CardFooter, CardHeader, Col } from "reactstrap";
import ReactToPrint from "react-to-print";
import "./newqr.css";
import $ from "jquery";
import CustomerInfoTable from "../../screens/common/CustomerInfoTable";
import { configuration } from "../../appConfig";
import Axios from "axios";
import CustomerInfoTable_newswiss from "../../screens/common/CustomerInfoTable_newswiss";
import Newswiss_CustomerInfoTable from "../../screens/common/newswiss_CustomerInfoTable";
import ReportHeader_Swiss from "../../screens/common/ReportHeader_Swiss";
import ReportFooter_Swiss from "../../screens/common/ReportFooter_Swiss";
import NewQrHeader from "../../screens/common/NewQrHeader";
import NewQrFooter from "../../screens/common/NewQrFooter";
const partnerId = localStorage.getItem("partnerId");
const vin = localStorage.getItem("selectedFile");

export default class NewQr extends React.Component {
    state = {
        lang: "",
        words: {},
        qrDetails: {},
    };
    async componentDidMount() {
        const { qrDetails } = this.state;
        this.getLang();
        // <script type="text/javascript">
        await this.getQRDetails();
    }
    CreateQR = () => {
        const { qrDetails } = this.state;
        const client = localStorage.getItem("client");
        var query = {
            cht: "qr",
            choe: "UTF-8",
            chs: "500x500",
            chld: "30",
            // chl: `estimateID="";vin=${localStorage.getItem(
            // "selectedFile"
            // )};make="";model="";color=""`,
            chl: `client=${qrDetails.client || ""}&claimNumber=${qrDetails.claimNumber || ""
                }&customerCompany=${qrDetails.customerCompany || ""}&OrderNo=${qrDetails.estimateId || ""
                }&RegNo=${qrDetails.reg || ""}&Make=${qrDetails.make || ""}&ActualVin=${client === "SWISS" || client === "POLAND" ? qrDetails.actualVin || "" : qrDetails.vin || ""
                }&Model=${qrDetails.model || ""}&PartnerName=${qrDetails.customerName || ""
                }&Color=${qrDetails.color || ""}`,
        };
        var url = "https://chart.apis.google.com/chart?" + $.param(query);
        $("#link").attr("src", url);
    };
    getQRDetails = () => {
        let url =
            configuration.getSingleQRDetails +
            "?partnerId=" +
            partnerId +
            "&vin=" +
            vin +
            "&qr_type=" +
            1;
        Axios.get(url)
            .then((res) => {
                if (res.data.data.length) {
                    this.setState({
                        qrDetails: res.data.data[0],
                    });
                }
            })
            .catch((err) => console.log(err))
            .finally(() => this.CreateQR());
    };
    count = [];
    pageLanguage = {
        ch: "Seite",
        fr: "Page",
        en: "Page",
    };
    pageOfLanguage = {
        ch: "von",
        fr: "de",
        en: "of",
    };

    getLang = () => {
        const base_url = window.location.origin;
        Axios.get(`${base_url}/lang.json`).then((res) => {
            this.setState({
                words: res.data,
                lang: localStorage.getItem("lang"),
            });
        });
    };
    lang = (word) => {
        const { lang, words } = this.state;
        return words[word] ? words[word][lang] : word;
    };
    render() {
        const client = localStorage.getItem("client");
        const { qrDetails } = this.state;
        return (
            <>
                <div className="animated fadeIn swissNewFullReport">
                    <div xs="12" sm="12" className="p-2">
                        <Card className="print_button_card mt-2">
                            <CardHeader>
                                <div className="container-fluid">
                                    <div className="row align-items-center p-0">
                                        <div className="col-lg-3 col-md-6 col-sm-12 col-12 mt-sm-10">
                                            <small>
                                                <span>{this.lang("VIN Number")} : </span>
                                                {localStorage.getItem("selectedFile")}
                                            </small>
                                        </div>
                                        <div className="col-lg-9 col-md-6 col-sm-12 col-12 mt-sm-10 p-0">
                                            <div className="d-flex align-items-center justify-content-end flex-wrap btn-position">
                                                <ReactToPrint
                                                    trigger={() => {
                                                        document.title =
                                                            localStorage.getItem("selectedFile");
                                                        return (
                                                            <button className="glass btn btn-lg btn-danger pull-right">
                                                                <i className="fa fa-print" />
                                                                &nbsp;{this.lang("Print PDF")}
                                                            </button>
                                                        );
                                                    }}
                                                    content={() => this.componentRef}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </CardHeader>
                        </Card>
                        <div
                            className="container newqr_main_page_wrapper all-reports-top-wrapper"
                            ref={(el) => (this.componentRef = el)}
                            style={{ padding: 0 }}
                            data-content-name={this.pageOfLanguage[this.state.lang]}
                        >
                            <div
                                className="row row-zero page-break-row report-full-wrapper"
                                data-content-name={this.pageLanguage[this.state.lang]}
                            >
                                <div className="col-sm-12 main-col-full p-0 newqr_main_wrapper">
                                    <Card>
                                        <div className="p-0 mb-0 newqr_main_header">
                                            <div className="newqr-header">
                                                <NewQrHeader />
                                            </div>
                                        </div>
                                        <CardBody className="p-0 mb-5 mt-3 newqr_main_body">
                                            <div className="qr_image_wrapper">
                                                <div className="text-center">
                                                {/* <img src={`data:image/png;base64,${qrDetails.qr_base64}`} className="m-auto" style={{width:" 85%"}} /> */}
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardFooter className="p-0 mb-5">
                                            <div className="p-0 mb-0 newqr_main_footer">
                                                <div className="newqr-footer">
                                                    <NewQrFooter />
                                                </div>
                                            </div>
                                        </CardFooter>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
